<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Input from 'dashboard/components-next/input/Input.vue';

const props = defineProps({
  hasSavedToken: { type: Boolean, default: false },
});

const apiUrl = defineModel('apiUrl', { type: String, default: '' });
const token = defineModel('token', { type: String, default: '' });

const { t } = useI18n();
const showToken = ref(false);

const tokenMessage = computed(() =>
  props.hasSavedToken && !token.value?.trim()
    ? t('INTEGRATION_SETTINGS.LIXFOLLOW.CONNECTION.ACCESS_TOKEN.REPLACE_HINT')
    : t('INTEGRATION_SETTINGS.LIXFOLLOW.CONNECTION.ACCESS_TOKEN.HELP')
);
</script>

<template>
  <Input
    v-model="apiUrl"
    :label="$t('INTEGRATION_SETTINGS.LIXFOLLOW.CONNECTION.API_URL.LABEL')"
    :placeholder="
      $t('INTEGRATION_SETTINGS.LIXFOLLOW.CONNECTION.API_URL.PLACEHOLDER')
    "
    :message="$t('INTEGRATION_SETTINGS.LIXFOLLOW.CONNECTION.API_URL.HELP')"
  />
  <Input
    v-model="token"
    :type="showToken ? 'text' : 'password'"
    :label="$t('INTEGRATION_SETTINGS.LIXFOLLOW.CONNECTION.ACCESS_TOKEN.LABEL')"
    :placeholder="
      $t('INTEGRATION_SETTINGS.LIXFOLLOW.CONNECTION.ACCESS_TOKEN.PLACEHOLDER')
    "
    :message="tokenMessage"
    custom-input-class="ltr:!pr-20 rtl:!pl-20"
  >
    <template #prefix>
      <button
        type="button"
        class="absolute z-10 top-[2.35rem] text-xs text-n-slate-10 hover:text-n-slate-12 transition-colors ltr:right-3 rtl:left-3"
        @click="showToken = !showToken"
      >
        {{
          showToken
            ? $t('INTEGRATION_SETTINGS.LIXFOLLOW.CONNECTION.ACCESS_TOKEN.HIDE')
            : $t('INTEGRATION_SETTINGS.LIXFOLLOW.CONNECTION.ACCESS_TOKEN.SHOW')
        }}
      </button>
    </template>
  </Input>
</template>
